import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const PaymentDetailsCard = ({
  payment_id,
  order_id,
  program,
  amount,
  installment,
  installment_number,
}) => (
  <div
    className="network-card p-8 mb-8"
    data-testid="payment-success-details-card"
  >
    <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
      <CheckCircle2 className="text-brand-primary" size={28} aria-hidden="true" />
      Payment Confirmed
    </h2>

    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-text-muted text-sm">Payment ID</p>
          <p
            className="text-white font-mono text-sm"
            data-testid="payment-success-payment-id"
          >
            {payment_id}
          </p>
        </div>
        <div>
          <p className="text-text-muted text-sm">Order ID</p>
          <p
            className="text-white font-mono text-sm"
            data-testid="payment-success-order-id"
          >
            {order_id}
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 pt-4">
        <p className="text-text-muted text-sm mb-2">Program Enrolled</p>
        <p className="text-white font-semibold text-lg">{program?.name}</p>
      </div>

      <div className="grid grid-cols-2 gap-4 border-t border-white/10 pt-4">
        <div>
          <p className="text-text-muted text-sm">Amount Paid</p>
          <p className="text-brand-accent font-bold text-2xl">
            ₹{amount?.toLocaleString('en-IN')}
          </p>
        </div>
        <div>
          <p className="text-text-muted text-sm">Payment Type</p>
          <p className="text-white font-semibold">
            {installment ? `Installment ${installment_number}/2` : 'Full Payment'}
          </p>
        </div>
      </div>

      {installment && installment_number === 1 && (
        <div className="bg-brand-accent/10 border border-brand-accent/30 rounded-lg p-4">
          <p className="text-sm text-text-secondary">
            <strong className="text-brand-accent">Next Step:</strong> Your second
            installment payment will be due soon. We'll contact you via WhatsApp
            and email with payment details.
          </p>
        </div>
      )}
    </div>
  </div>
);

export default PaymentDetailsCard;
